export default __webpack_public_path__ + "static/media/rejectImg.26a7e556.svg";